module.exports = __webpack_public_path__ + "static/media/home-backround.6808a01d.png";